import Navigation from "@/components/navigation/Navigation.vue";
import PerfilService from "../../services/PerfilService";

export default {
  components: {
    Navigation,
  },
  name: "Header",

  data: () => ({
    drawer: false,
    user: [],
  }),

 async beforeMount(){
    this.$store.state.user = await PerfilService.getPerfilUser();
    this.user = this.$store.state.user 
  },

  methods: {
    logout() {
      localStorage.removeItem('perfil_hir')
      localStorage.removeItem('perfil_id')
      localStorage.removeItem('perfil_label')
      localStorage.removeItem('user_id')
      localStorage.removeItem('session_id')
      localStorage.removeItem('perfil_label')
      this.$keycloak.logout();
    },

    redirectLogin() {
      this.$keycloak.login();
    },


    goTo() {
      this.$router.push("/");
    }
  }
};